import { createRoute } from '@tanstack/react-router'
import { EditUserPage } from '@/features/users/pages/EditUserPage'
import { Route as usersRoute } from '../../users/route'

export const Route = createRoute({
  getParentRoute: () => usersRoute,
  path: '/edit/$id',
  component: EditUserPage,
})
